/**
 * @generated SignedSource<<b68a3fe5782d2b09f1f7aea8ee771340>>
 * @relayHash 4100de47227c3a1250ad701f85dc14ef
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4100de47227c3a1250ad701f85dc14ef

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type setTodoCustomerInput = {
  clientMutationId?: string | null | undefined;
  customerId?: string | null | undefined;
  todoId: string;
};
export type TodoMutations_SetCustomerMutation$variables = {
  input: setTodoCustomerInput;
};
export type TodoMutations_SetCustomerMutation$data = {
  readonly setTodoCustomer: {
    readonly todo: {
      readonly customer: {
        readonly " $fragmentSpreads": FragmentRefs<"CustomerFatQuery_data">;
      } | null | undefined;
    };
  } | null | undefined;
};
export type TodoMutations_SetCustomerMutation = {
  response: TodoMutations_SetCustomerMutation$data;
  variables: TodoMutations_SetCustomerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoMutations_SetCustomerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "setTodoCustomerPayload",
        "kind": "LinkedField",
        "name": "setTodoCustomer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "customer",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CustomerFatQuery_data"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoMutations_SetCustomerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "setTodoCustomerPayload",
        "kind": "LinkedField",
        "name": "setTodoCustomer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "customer",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "printName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "4100de47227c3a1250ad701f85dc14ef",
    "metadata": {},
    "name": "TodoMutations_SetCustomerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "97dea99dfb7914338e90aea924b1b23a";

export default node;
